import { axiosJwt } from '@/shared/auth/axios-lib'
import { errorHandler } from '@/shared/errorHandler'

const api = `${process.env.VUE_APP_API_URL}${process.env.VUE_APP_API_PATH}`

export default {
    obterTodos() {
        let url = `${api}/contratos/irregularidades`
        return axiosJwt
            .get(url)
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    obterGradacoes() {
        let url = `${api}/contratos/irregularidades/gradacoes`
        return axiosJwt
            .get(url)
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    inserirIrregularidade(irregularidade) {
        return axiosJwt
            .post(`${api}/contratos/irregularidades`, irregularidade)
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    atualizarIrregularidade(irregularidade) {
        return axiosJwt
            .put(`${api}/contratos/irregularidades/${irregularidade.idIrregularidade}`, irregularidade)
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    ativarDesativarIrregularidade(irregularidade) {
        return axiosJwt
        .patch(`${api}/contratos/irregularidades/${irregularidade.idIrregularidade}/ativar-desativar`, irregularidade)
        .then(response => {
            return response.data
        })
        .catch(error => {
            return errorHandler(error)
        })
    }
}
